<template>
  <v-dialog
      v-model="dialog"
      max-width="900"
      style="overflow: hidden !important"
  >
    <v-card>
      <v-card-title>
        {{
          processType === "new"
              ? "Depo Ekle"
              : "Depo Düzenle"
        }}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <v-text-field
                  solo
                  filled
                  dense
                  v-model="name"
                  label="Depo Adı"
                  :error-messages="
                  validationMessages($v.name, 'Depo Adı')
                "
                  prepend-inner-icon="mdi-page-layout-header"
                  @input="$v.name.$touch()"
                  @blur="$v.name.$touch()"
              ></v-text-field>
            </div>
            <div class="col-lg-12">
              <v-select
                  v-model="erpCode"
                  label="Depo Seçimi"
                  filled
                  solo
                  dense
                  clearable
                  :items="erpWarehouseList"
                  item-value="code"
                  item-text="name"
              ></v-select>
            </div>
            <div class="col-lg-6">
              <v-switch
                  solo
                  filled
                  dense
                  v-model="isActive"
                  inset
                  :label="
                  isActive
                    ? 'Durum : ' + 'Aktif'
                    : 'Durum : ' + 'Pasif'
                "
              ></v-switch>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="closeDialog()">İptal</v-btn>
        <v-btn text color="success" @click="saveForm">Kaydet</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {validationMessages} from "@/validationMessages.js";

export default {
  mixins: [validationMixin],
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    warehouseProp: {
      type: Object,
      default: () => ({
        id: null,
        name: "",
        isActive: true
      })
    },
    processType: {
      type: String,
      required: true
    }
  },
  name: "EditWarehouseDialog",
  validations () {
    return {
      name: {required},
    }
  },
  data() {
    return {
      dialog: false,
      name: "",
      isActive: true,
      erpCode: null,
    };
  },
  computed: {
    ...mapState("company", ["erpWarehouseList"])
  },
  methods: {
    ...mapActions("company", ["companyWarehouseAdd", "companyWarehouseUpdate","fetchErpWarehouseList"]),
    validationMessages,
    closeDialog() {
      this.dialog = false;
      this.name = "";
      this.$v.$reset();
    },
    async _fetchWarehouseList() {
      await this.fetchErpWarehouseList({
        params: {},
        body: {}
      });
    },
    async saveForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.processType === "new") {
          await this.companyWarehouseAdd({
            params: {},
            body: {
              name: this.name,
              isActive: this.isActive,
              erpCode: this.erpCode
            },
            urlSegments: [],
          });
        } else {
          await this.companyWarehouseUpdate({
            params: {},
            body: {
              id: this.warehouseProp.id,
              name: this.name,
              isActive: this.isActive,
              erpCode: this.erpCode
            },
            urlSegments: [],
          })
        }
        this.closeDialog();
      }
    }
  },
  mounted() {
    this._fetchWarehouseList();
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
    warehouseProp: function (newVal) {
      this.name = newVal.name;
      this.isActive = newVal.isActive;
      this.erpCode = newVal.erpCode;
    }
  }
}
</script>

<style scoped>

</style>